export default __webpack_public_path__ + "static/4-6014b84ddefb85a2e3174a8a47ac8b08.png";